import * as yup from 'yup';
import { memoize } from 'lodash';

import TranslationHelper from '../helpers/TranslationHelper';
import {
    DESCRIPTION_STRING_MAX_LENGTH,
    NAME_STRING_MAX_LENGTH,
    FIELD_REQUIRED,
    VALUE_TOO_LONG,
    REGEXP_NOT_MATCHES,
} from '../constants/yup';
import { tryParseRegex } from '../helpers/isMatchWithRegex';

export const attributesSchema = memoize(() =>
    yup.object().shape({
        id: yup.string(),
        name: yup
            .string()
            .trim()
            .when('id', {
                is: undefined,
                then: (schema) =>
                    schema
                        .required(TranslationHelper.translate(FIELD_REQUIRED))
                        .max(
                            NAME_STRING_MAX_LENGTH,
                            TranslationHelper.translate(VALUE_TOO_LONG)
                        )
                        .matches(
                            /^[a-zA-Z0-9_-]*$/,
                            TranslationHelper.translate(
                                'Valid characters are A-Z a-z 0-9 _ -'
                            )
                        ),
            }),
        regex: yup
            .string()
            .trim()
            .max(
                NAME_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            )
            .test(
                'is-valid-regex',
                TranslationHelper.translate('Invalid regular expression'),
                (value) => !value || tryParseRegex(value) !== null
            ),

        type: yup
            .number()
            .required(TranslationHelper.translate(FIELD_REQUIRED)),

        dictionary: yup.array().when('regex', (regex: string, schema: any) => {
            const parsedRegex = tryParseRegex(regex);
            return schema.of(
                yup.object().shape({
                    name: yup
                        .string()
                        .trim()
                        .required(TranslationHelper.translate(FIELD_REQUIRED))
                        .max(
                            NAME_STRING_MAX_LENGTH,
                            TranslationHelper.translate(VALUE_TOO_LONG)
                        ),
                    value: yup
                        .string()
                        .trim()
                        .required(TranslationHelper.translate(FIELD_REQUIRED))
                        .max(
                            NAME_STRING_MAX_LENGTH,
                            TranslationHelper.translate(VALUE_TOO_LONG)
                        )
                        .matches(
                            parsedRegex ?? /.*/, // fallback to match-all regex
                            {
                                excludeEmptyString: true,
                                message:
                                    TranslationHelper.translate(
                                        REGEXP_NOT_MATCHES
                                    ),
                            }
                        ),
                    label: yup
                        .string()
                        .trim()
                        .required(TranslationHelper.translate(FIELD_REQUIRED))
                        .max(
                            DESCRIPTION_STRING_MAX_LENGTH,
                            TranslationHelper.translate(VALUE_TOO_LONG)
                        ),
                })
            );
        }),

        label: yup
            .string()
            .trim()
            .required(TranslationHelper.translate(FIELD_REQUIRED))
            .max(
                NAME_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            ),
    })
);
